export default __webpack_public_path__ + "static/media/whatsapp_link_icon.a35053ba.svg";